import Axios from "axios";

export function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}


Axios.defaults.withCredentials = true;
let uid = window.sessionStorage.getItem('uid');
if(!uid){
    uid = uuidv4();
    window.sessionStorage.setItem('uid',uid);
}

Axios.defaults.headers.uid = uid;


const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const carvanaTrackingURL = process.env.REACT_APP_CARVANA_TRACKING_URL;
export const carvanaActive = process.env.REACT_APP_CARAVANA_ACTIVE
export function fetchCarMakes(oem){
    const urlParams = encodeURIComponent(window.location.search);
    return Axios.get(`${BASE_URL}/makes?${oem?`oem=${oem}&`:''}urlParams=${urlParams}`).then(res=>{
        return res.data.sort().map((value)=>{
            return {
                value: value,
                name: value
            }
        })
    });
}

export function fetchTopNModels(make){
    const urlParams = encodeURIComponent(window.location.search);
    return Axios.get(`${BASE_URL}/autos${make?`/${make}`:''}/models/topn?urlParams=${urlParams}`).then(res=>{
        return res.data.sort().map((value)=>{
            return {
                value: value,
                name: value
            }
        })
    });
}


export function fetchCarsDump(){
    const urlParams = encodeURIComponent(window.location.search);
    return Axios.get(`${BASE_URL}/autos/listing?urlParams=${urlParams}`).then(res=>{
        return res.data;
    });
}

export function fetchCarModelsDump(make){
    const urlParams = encodeURIComponent(window.location.search);
    return Axios.get(`${BASE_URL}/autos?make=${make}&urlParams=${urlParams}`).then(res=>{
        return res.data;
    });
}


export function fetchCarModels(make){
    const urlParams = encodeURIComponent(window.location.search);
    return Axios.get(`${BASE_URL}/autos?make=${make}&urlParams=${urlParams}`).then(res=>{
        let temp = [];
        res.data.forEach((car) => {
            const alreadyExistsIndex = temp.findIndex(_=>_.name === car.model);
            if(alreadyExistsIndex === -1){
                return temp.push({
                    value: car.model,
                    name: car.model,
                    oem: car.dealershipOem,
                    autoId: car.id 
                })
            }
        });
        temp.sort((a,b)=>a.name>b.name?1:-1)
        return temp
    });
}

export function fetchCarYears(make, model){
    const urlParams = encodeURIComponent(window.location.search);
    return Axios.get(`${BASE_URL}/autos?make=${make}&model=${model}&urlParams=${urlParams}`).then(res=>{
        let temp = [];
        res.data.forEach((car) => {
            const alreadyExistsIndex = temp.findIndex(_=>_.name === car.year);
            if(alreadyExistsIndex === -1){
                return temp.push({
                    value: car.year,
                    name: car.year
                })
            }
        });
        temp.sort(function(year1, year2){return year2.value - year1.value})
        return temp
    });
}

export function fetchCarTrims(make,model,year){
    const urlParams = encodeURIComponent(window.location.search);
    return Axios.get(`${BASE_URL}/autos?make=${make}&model=${model}&year=${year}&urlParams=${urlParams}`).then(res=>{
        
        return res.data.map((car)=>{
            return {
                value: car.titleWithPrice,
                name: car.titleWithPrice,
                id: car.id,
                image: car.imageUrls ? car.imageUrls[0] : null,
                price: car.price,
                mileageCity: car.mileageCity,
                mileageHwy: car.mileageHwy,
                numberOfSeats: car.numberOfSeats,
                fuelTankCapacity: car.fuelTankCapacity,
                recommendedPrice: car.recommendedPrice,
                oem: car.dealershipOem,
                segment: car.segment
            }
        })
    })
}

export function fetchCarDealers(make,model,year,zipCode = null,oem, size = 6,tmpl,trim){

    const urlParams = encodeURIComponent(window.location.search);
    return Axios.get(`${BASE_URL}/dealers?make=${make}&model=${model}&year=${year}&size=${size}${oem?`&oem=${oem}`:''}${zipCode?`&zipcode=${zipCode}`:''}&tmpl=${tmpl}&trim=${trim}&urlParams=${urlParams}`).then(res=>{
        return {
            zipcode: res?.data?.zipcode,
            statecode: res?.data?.statecode,
            city: res?.data?.city,
            oemSubmissionId: res?.data?.oemSubmissionId,
            dealers: res?.data?.dealers?.map(_=>{
                return {
                    id: _.id,
                    name: _.name?_.name.toLowerCase():_.name,
                    distance: _.distance,
                    address: _.address,
                    city: _.city,
                    state: _.state,
                    postalCode: _.postalCode,
                    phone: _.phone,
                    dealershipOem: _.dealershipOem,
                    programId: _.programId,
                    dealerCode: _.dealerCode
                }
            })
        }
    })
}


export function submitLead(data){
    data.urlParams = encodeURIComponent(window.location.search)
    return Axios.post(`${BASE_URL}/submissions`,data);
}

export function fetchCarDealersViaPhonexa(payload) {
    const urlParams = new URLSearchParams(window.location.search);
    if(payload?.zipCode){
        urlParams.set('zip', payload.zipCode);
    }
    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
    const encodedUrlParams = encodeURIComponent(urlParams.toString());
    
    return fetch(
      `${process.env.REACT_APP_PHONEXA_API_BASE_URL}/dealers?make=${payload.make}&model=${payload.model}&year=${payload.year}&size=${payload.size}${ payload.oem ? `&oem=${payload.oem}` : "" }${payload.zipCode ? `&zip=${payload.zipCode}` : ""}&tmpl=${payload.tmpl}&trim=${payload.trim}&userIp=${payload.userIp}&webSiteUrl=${ encodeURIComponent(payload.websiteUrl) }&leadURL=${encodeURIComponent(window.location.href)}&source=${payload.source}&api_key=${payload["api_key"]}&utmParams=${encodedUrlParams}&mnetVisitorId=${payload.mnetVisitorId}`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok " + response.statusText);
        }
        return response.json();
      })
      .then((res) => {
        return {
          zipcode: res?.data?.zipCode,
          statecode: res?.data?.stateCode,
          city: res?.data?.city,
          oemSubmissionId: res?.data?.oemSubmissionId,
          promise: res?.data?.promise,
          formSubmissionId:res?.data?.formSubmissionId,
          reservationCode:res?.data?.reservationCode,
          createdDate:res?.data?.createdDate,
          webSiteUrl:res?.data?.webSiteUrl,
          dealers: res?.data?.dealers?.map((_) => {
            return {
              id: _.dealerCode,
              name: _.dealerName,
              distance: _.distance,
              address: _.address,
              city: _.city,
              state: _.state,
              postalCode: _.postalCode,
              phone: _.phoneNumber,
              dealershipOem: _.dealershipOem,
              programId: _.programId,
              dealerCode: _.dealerCode,
            };
          }),
        };
      });
}

export async function submitPhonexaLead(data){
    try {
        const response = await fetch(`${process.env.REACT_APP_PHONEXA_API_BASE_URL}/submissions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error submitting lead:', error);
    }
}

export function submitUsedCarLead(data){
    data.urlParams = encodeURIComponent(window.location.search)
    return Axios.post(`${BASE_URL}/usedcarsubmissions`,data);
}

export function submitDuration(data){
    data.urlParams = encodeURIComponent(window.location.search)
    return Axios.post(`${BASE_URL}/leads/duration`,data);
}

export function newLetterSubscription(data){
    data.urlParams = window.location.search
    return Axios.post(`${BASE_URL}/subscription`,data)
}

export function privacyOptOut(data){
    data.urlParams = encodeURIComponent(window.location.search)
    return Axios.post(`${BASE_URL}/privacy-opt-out`,data)
}

export function sendFeedback(data){
    data.urlParams = encodeURIComponent(window.location.search)
    return Axios.post(`${BASE_URL}/feedback`,data)
}

export function fetchPrivacyRequestTypes(){
    const urlParams = encodeURIComponent(window.location.search);
    return Axios.get(`${BASE_URL}/privacy-policies?urlParams=${urlParams}`)
}

export function createCrossSellMapping(data) {
    data.urlParams = encodeURIComponent(window.location.search)
    return Axios.post(`${BASE_URL}/cross_sell`,data)
}

export function fetchUsedCarsDump(){
    // const urlParams = encodeURIComponent(window.location.search);
    return Axios.get(`${BASE_URL}/autos/usedcar`).then(res=>{
        return res;
    });
}

export function fetchUsedCarsDumpWithZip(zip){
    // const urlParams = encodeURIComponent(window.location.search);
    return Axios.get(`${BASE_URL}/autos/usedcar?zipcode=${zip}`).then(res=>{
        return res;
    });
}

export function fetchNewCarsDump(zip){
    // const urlParams = encodeURIComponent(window.location.search);
    return Axios.get(`${BASE_URL}/autos?zipcode=${zip}`).then(res=>{
        return res.data;
    });
}


export function fetchLocationDetails(){
    return Axios.get(`${BASE_URL}/location`).then(res=>{
        return res;
    });
}